import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../constent";

export const subscribeUser = createAsyncThunk(
  "subscribe/subscribeUser",
  async (email, thunkAPI) => {
    try {
      // console.log(email)
      const response = await axios.post(`${API_URL}/subscriber`, { email });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Subscription failed. Please try again.";
      return thunkAPI.rejectWithValue({ message });
    }
  }
);

const subscribeSlice = createSlice({
  name: "subscribe",
  initialState: {
    loading: false,
    success: false,
    error: null,
    message: null,
  },
  reducers: {
    resetSubscribeState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(subscribeUser.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.message = null;
      })
      .addCase(subscribeUser.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = "Subscription successful!";
      })
      .addCase(subscribeUser.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload?.message || "Subscription failed";
      });
  },
});

// Export reducer and actions
export const { resetSubscribeState } = subscribeSlice.actions;
export default subscribeSlice.reducer;
